import './../Filter/Filter.scss';
import Component from './VendorListFilter.js';
export default Component;